import {
	Component,
	OnInit,
	OnDestroy,
	ViewChild,
	ElementRef,
	ChangeDetectorRef,
	ChangeDetectionStrategy,
} from '@angular/core';

import { Router, NavigationEnd, NavigationStart } from '@angular/router';

import { CoreService } from '@jepto/core/services/core.service';
import { JepCurrentAccountService } from '@jepto/shared/services/jep-current-account/jep-current-account.service';
import { JepGlobalDataService } from '@jepto/shared/services/jep-global-data/jep-global-data.service';

import { DropdownToggle } from '@jepto/shared/animations/jep-animations';

import { Subject, takeUntil, filter } from 'rxjs';
import { filter as _filter } from 'lodash';
import {
	dynamicKeySort,
	searchURLParams,
	sortKeySplitter,
} from '@jepto/shared/utils/collection';

import { markForCheckOnEmit } from '@jepto/shared/utils/change-detection';
@Component({
	selector: 'global-pipelines-dropdown',
	templateUrl: 'global-pipelines-dropdown.component.html',
	styleUrls: ['./global-pipelines-dropdown.component.scss'],
	animations: [DropdownToggle()],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class GlobalPipelinesDropdownComponent implements OnInit, OnDestroy {
	constructor(
		public coreService: CoreService,
		public jepCurrentAccountService: JepCurrentAccountService,
		public jepGlobalDataService: JepGlobalDataService,
		private cdRef: ChangeDetectorRef,
		private router: Router
	) {
		this.getUrlParams();
	}
	@ViewChild('search') search: ElementRef;
	@ViewChild('dropdownPipelines') dropdownPipelines: ElementRef;
	unsubscribe$ = new Subject<void>();
	accountId: string;
	pipelinesUnderAccount: Array<any> = [];
	tempPipelinesUnderAccount: Array<any> = [];
	selectedPipeline: any = null;
	dropdownBoxState: 'hide' | 'show' = 'hide';
	dropdownListHeight: number;
	searchText: string;
	noResults: boolean = false;
	isLoading: boolean = true;
	urlParams: {
		properties: string;
		dateRange: string;
		interval: string;
		aggregation: string;
		option: string;
		value: string;
	} = null;
	pipelineId: string = null;

	ngOnInit(): void {
		console.log('clg init pipeline');
		this.autoRun();
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	autoRun(): void {
		this.initialiser();
		this.listener();
	}

	initialiser(): void {
		this.accountId = this.jepCurrentAccountService.getAccountId();
	}

	listener(): void {
		// The layout can render before the Cognito session resolves; listing
		// then would query pipelines for an empty account id.
		this.jepCurrentAccountService
			.accountId$()
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(accountId => {
				this.accountId = accountId;
				this.listAllPipelinesUnderAccount();
			});
		this.listenRouterChange();
	}

	listenRouterChange(): void {
		this.router.events
			.pipe(
				filter(event => event instanceof NavigationEnd),
				markForCheckOnEmit(this.cdRef),
				takeUntil(this.unsubscribe$)
			)
			.subscribe(event => {
				if (event instanceof NavigationEnd) {
					if (event.url === '/analysis') {
						this.routeToSelectedPipelineAnalysis(
							this.selectedPipeline
						);
					}
					if (event.url === '/extensions') {
						this.routeToSelectedPipelineExtension(
							this.selectedPipeline,
							'search-explorer'
						);

						// if (this.router.url.includes("questions")) this.routeToSelectedPipelineExtension(this.selectedPipeline, "questions");
					}
				}
			});
	}
	getUrlParams(): void {
		const routerURL: string = window.location.href;
		this.urlParams = {
			properties: searchURLParams(routerURL, 'properties'),
			dateRange: searchURLParams(routerURL, 'dateRange'),
			interval: searchURLParams(routerURL, 'interval'),
			aggregation: searchURLParams(routerURL, 'aggregation'),
			option: searchURLParams(routerURL, 'option'),
			value: searchURLParams(routerURL, 'value'),
		};
		this.pipelineId = this.router.url.split('/')[2];
	}

	listAllPipelinesUnderAccount(): void {
		this.coreService
			.listPipelinesUnderAccount(this.accountId, '', false)
			.pipe(markForCheckOnEmit(this.cdRef), takeUntil(this.unsubscribe$))
			.subscribe(
				(result: { state: boolean; data: any[]; message: string }) => {
					if (result.state) {
						if (result.data.length) {
							this.readPipelines(result.data);
							setTimeout(() => {
								this.setPipelineListHeightClass();
								this.cdRef.markForCheck();
							});
							this.jepGlobalDataService.setPipelines({
								state: true,
								data: this.pipelinesUnderAccount,
								selected: this.selectedPipeline,
							});
						} else {
							this.jepGlobalDataService.setPipelines({
								state: true,
								data: [],
								selected: null,
							});
						}
					} else {
						this.jepGlobalDataService.setPipelines({
							state: false,
							data: [],
							selected: null,
						});
					}
					this.isLoading = false;
				}
			);
	}

	readPipelines(data: Array<any>): void {
		this.pipelinesUnderAccount = this.getPipelineUnderAccount(data);
		if (Boolean(this.pipelineId)) {
			let _selectedPipeline: Array<any> = _filter(
				this.pipelinesUnderAccount,
				{ sortKey: `pipeline#v0#${this.pipelineId}` }
			);
			if (_selectedPipeline.length) {
				this.selectedPipeline = _selectedPipeline[0];
			} else {
				this.setDefaultPipeline(this.pipelinesUnderAccount[0]);
			}
		} else {
			this.setDefaultPipeline(this.pipelinesUnderAccount[0]);
		}
	}

	setDefaultPipeline(pipeline: any): void {
		this.selectedPipeline = pipeline;
		if (this.router.url.includes('/extensions')) {
			this.routeToSelectedPipelineExtension(
				this.selectedPipeline,
				'search-explorer'
			);
		} else {
			this.routeToSelectedPipelineAnalysis(this.selectedPipeline);
		}
	}

	routeToSelectedPipelineExtension(
		selectedPipeline: any,
		path: string
	): void {
		if (selectedPipeline !== null) {
			console.log('clg path', path);
			const id: string = sortKeySplitter(
				selectedPipeline.sortKey,
				'#',
				2
			);
			const sourceType = selectedPipeline.source.sourceType;
			const selectedSourceType: 'gsc' | 'gmb' | 'fb' =
				sourceType === 'FACEBOOK' ? 'fb' : sourceType.toLowerCase();
			console.log('clg selectedSourceType', selectedSourceType);
			if (selectedSourceType === 'gsc') {
				this.router.navigate([
					'extensions',
					id,
					'explorer',
					selectedSourceType,
					path === null ? 'search-explorer' : path,
				]);
			} else {
				this.router.navigate([
					'extensions',
					id,
					'explorer',
					selectedSourceType,
				]);
			}
		} else {
			this.router.navigate(['extensions']);
		}
	}

	routeToSelectedPipelineAnalysis(selectedPipeline: any): void {
		console.log('clg f', selectedPipeline);
		if (selectedPipeline !== null) {
			const id: string = sortKeySplitter(
				selectedPipeline.sortKey,
				'#',
				2
			);
			const sourceType = selectedPipeline.source.sourceType;
			const selectedSourceType: 'gsc' | 'gmb' | 'fb' =
				sourceType === 'FACEBOOK' ? 'fb' : sourceType.toLowerCase();
			if (
				this.urlParams !== null &&
				(Boolean(this.urlParams.properties) ||
					Boolean(this.urlParams.dateRange) ||
					Boolean(this.urlParams.interval) ||
					Boolean(this.urlParams.aggregation) ||
					Boolean(this.urlParams.option) ||
					Boolean(this.urlParams.value))
			) {
				console.log(
					'clg merge',
					this.urlParams,
					this.pipelineId,
					selectedSourceType
				);
				this.router.navigate(
					['analysis', this.pipelineId, selectedSourceType],
					{
						queryParams: this.urlParams,
						queryParamsHandling: 'merge',
					}
				);
				this.urlParams = null;
				this.pipelineId = null;
			} else {
				console.log('clg select', selectedSourceType);
				this.router.navigate(['analysis', id, selectedSourceType]);
			}
		} else {
			this.router.navigate(['analysis']);
		}
	}

	getPipelineUnderAccount(data: Array<any>): Array<any> {
		const stash: Array<any> = data.map((item: any) => {
			item['logo'] = this.getLogo(item.source.sourceType);
			item['service'] = item['source']['sourceType'];
			return item;
		});
		// const stash = _filter(data, { sortKey: "pipeline#v0#0fc9ca4560d54aff" });
		// const stash = _filter(data, { sortKey: "pipeline#v0#d0d7d0e5987145e2" });
		// const stash = _filter(data, { sortKey: "pipeline#v0#e3fdbba60659409c" });
		const response = [...stash].sort(dynamicKeySort('-service'));
		this.tempPipelinesUnderAccount = response;
		return response;
	}

	getLogo(sourceType: 'GSC' | 'GMB' | 'FACEBOOK'): string {
		switch (sourceType) {
			case 'GSC':
				return 'assets/images/google-search-console.svg';
			case 'GMB':
				return 'assets/images/google-my-business.svg';
			case 'FACEBOOK':
				return 'assets/images/Facebook.svg';
		}
	}

	onSearch(event: string): void {
		const toSearch: string = event.toLowerCase();
		this.pipelinesUnderAccount = this.tempPipelinesUnderAccount.filter(
			(result: any) => {
				if (result.title.toLowerCase().includes(toSearch))
					return result;
			}
		);
		this.noResults = this.pipelinesUnderAccount.length === 0 ? true : false;
		this.setPipelineListHeightClass();
	}

	onClickedOutside(): void {
		this.dropdownBoxState = 'hide';
	}

	createNewPipeline(): void {
		this.router.navigate(['pipelines', 'create']);
	}

	toggleDropdownBoxState(event: Event): void {
		this.dropdownBoxState =
			this.dropdownBoxState === 'show' ? 'hide' : 'show';
		this.setPipelineListHeightClass();
	}

	setPipelineListHeightClass(): void {
		if (this.dropdownPipelines) {
			this.removeClass(this.dropdownPipelines, 'fixed-height');
			this.dropdownListHeight =
				this.dropdownPipelines.nativeElement.offsetHeight;
			this.dropdownPipelines.nativeElement.offsetHeight >= 272
				? this.addClass(this.dropdownPipelines, 'fixed-height')
				: this.removeClass(this.dropdownPipelines, 'fixed-height');
			this.cdRef.detectChanges();
		}
	}

	removeClass(elem, className): void {
		if (elem.nativeElement.classList.contains(className))
			elem.nativeElement.classList.remove(className);
	}

	addClass(elem, className): void {
		elem.nativeElement.classList.add(className);
	}

	selectPipeline(pipeline: any): void {
		this.selectedPipeline = pipeline;
		console.log('clg selectedPipeline', this.selectedPipeline);
		if (this.router.url.includes('/extensions')) {
			// this.routeToSelectedPipelineExtension(this.selectedPipeline,)
			console.log('clg 1', this.router.url.includes('search-explorer'));
			console.log('clg 2', this.router.url.includes('questions'));
			if (this.router.url.includes('search-explorer')) {
				this.routeToSelectedPipelineExtension(
					this.selectedPipeline,
					'search-explorer'
				);
			} else if (this.router.url.includes('questions')) {
				this.routeToSelectedPipelineExtension(
					this.selectedPipeline,
					'questions'
				);
			} else {
				this.routeToSelectedPipelineExtension(
					this.selectedPipeline,
					null
				);
			}
		} else {
			this.routeToSelectedPipelineAnalysis(this.selectedPipeline);
		}
		this.dropdownBoxState = 'hide';
		this.jepGlobalDataService.setPipelines({
			state: true,
			data: this.pipelinesUnderAccount,
			selected: this.selectedPipeline,
		});
	}

	createPipeline(): void {
		this.router.navigate(['pipelines', 'create']);
	}
}
